import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './AppRouter';
import Header from './components/header/Header';
// Refreshes cache on new web versions to keep it up-to-date
import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json';
import ScrollToTop from './ScrollToTop';

const App = () => {
  const [lang, setLang] = useState(() => {
    const storedLang = localStorage.getItem("lang");
    return storedLang === "en" || storedLang === "cz" ? storedLang : "cz";
  });
  // Needed to force re-render on setting new language
  const [key, setKey] = useState(Math.random());

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang === "en" ? "en" : "cs";
    setKey(Math.random);
  }, [lang]);

  return (
    <CacheBuster
      currentVersion={packageJson.version}
      isEnabled={true}
      isVerboseMode={false}
    >
      <Router key={key} lang={lang}>
        <ScrollToTop />
        <Header lang={lang} changeLanguage={setLang} />
        <AppRouter />
      </Router>
    </CacheBuster>
  );
};

export default App;
